export const PARENTESCOS = [
  { value: "Abuela", label: "Abuela" },
  { value: "Abuelo", label: "Abuelo" },
  { value: "Amiga", label: "Amiga" },
  { value: "Amigo", label: "Amigo" },
  { value: "Conyuge", label: "Cónyuge" },
  { value: "Hermana", label: "Hermana" },
  { value: "Hermano", label: "Hermano" },
  { value: "Hija", label: "Hija" },
  { value: "Hijo", label: "Hijo" },
  { value: "Madre", label: "Madre" },
  { value: "Padre", label: "Padre" },
  { value: "Pareja", label: "Pareja" },
  { value: "Prima", label: "Prima" },
  { value: "Primo", label: "Primo" },
  { value: "Tía", label: "Tía" },
  { value: "Tío", label: "Tío" },
];

export const SEXO = [
  { value: "M", label: "Masculino" },
  { value: "F", label: "Femenino" }
];

export const CARGO = [
  { value: "ADMINISTRATIVO", label: "Administrativo" },
  { value: "GERENTE", label: "Gerente" },
  { value: "SUBGERENTE", label: "Subgerente" },

  // OPERACIÓN
  { value: "CONDUCTOR", label: "Conductor" },
  { value: "COORDINADOR", label: "Coordinador" },

  // TALLER
  { value: "JEFE_TALLER", label: "Jefe de Taller" },
  { value: "TECNICO_TALLER", label: "Técnico de Taller" },
  { value: "MECANICO", label: "Mecánico" },

  // OTRAS AREAS
  { value: "PREVENCIONISTA", label: "Prevencionista" },
  { value: "TI", label: "TI" }
];

export const PERFIL = [
  { value: "trabajador", label: "Trabajador" },
  { value: "cliente", label: "Cliente" }
];

export const ESTADOS_CIVILES = [
  { value: "soltero", label: "Soltero(a)" },
  { value: "casado", label: "Casado(a)" },
  { value: "divorciado", label: "Divorciado(a)" },
  { value: "viudo", label: "Viudo(a)" },
  { value: "conviviente_civil", label: "Conviviente Civil (AUC)" },
  { value: "separado", label: "Separado(a)" }
];